import { ProgressBar } from "react-aria-components"
import { useTranslation } from "react-i18next"

import { useTheme } from "../../utilities/hooks/useTheme"

import styles from "./PendingComponent.module.css"

interface Props {
  variant?: "floating" | "block"
  design?: "demure" | "default"
  size?: "small" | "default"
  alwaysUsePrimary?: boolean
}

const PendingComponent = (props: Props) => {
  const center = props.size === "small" ? 12 : 20
  const strokeWidth = center * 0.2
  const r = center * 0.8
  const c = 2 * r * Math.PI
  const { t } = useTranslation()
  const { scannedArea, documentThemeMode } = useTheme()

  // Use primary colors when theme is loaded, neutral colors before theme loads
  // If alwaysUsePrimary is true, skip the theme check and always use primary colors
  const isThemeLoaded =
    props.alwaysUsePrimary ||
    (documentThemeMode === "whiteLabel" && scannedArea)
  const design = isThemeLoaded
    ? props.design === "demure"
      ? "demure"
      : "default"
    : props.design === "demure"
      ? "neutral-demure"
      : "neutral"

  return (
    <ProgressBar
      aria-label={t("common.loading")}
      isIndeterminate
      className={styles.loader}
      data-variant={props.variant || "floating"}
      data-design={design}
    >
      <svg
        width={center * 2}
        height={center * 2}
        viewBox={`0 0 ${center * 2} ${center * 2}`}
        fill="none"
        strokeWidth={strokeWidth}
      >
        <circle
          cx={center}
          cy={center}
          r={r - (strokeWidth / 2 - 2)}
          opacity={0.25}
        />
        <circle
          cx={center}
          cy={center}
          r={r}
          strokeDasharray={`${c} ${c}`}
          strokeDashoffset={c - 0.5 * c}
          strokeLinecap="round"
        />
      </svg>
    </ProgressBar>
  )
}

export default PendingComponent
